'use client';

import { Loader2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from './lib/utils';

function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  const { t } = useTranslation('ui');
  return (
    <Loader2Icon
      data-slot="spinner"
      role="status"
      aria-label={t('common:messages.loading')}
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
